export default __webpack_public_path__ + "static/media/6.83f6fdbd.png";